import ApiService from './ApiService';

class FotoarchivService {
  // Lade alle Fotoarchiv-Aktionen
  async getAktionen() {
    try {
      const result = await ApiService.get('/fotoarchiv');
      console.log('📂 Fotoarchiv GET /fotoarchiv Response:', result);
      // Verschiedene mögliche Response-Formate abfangen
      if (Array.isArray(result)) return result;
      if (result?.fotoarchive) return result.fotoarchive;
      if (result?.aktionen) return result.aktionen;
      if (result?.data) return result.data;
      return [];
    } catch (error) {
      console.error('Fehler beim Laden der Fotoarchiv-Aktionen:', error);
      return [];
    }
  }

  // Erstelle eine neue Fotoarchiv-Aktion
  async createAktion(data) {
    try {
      console.log('📤 Erstelle Fotoarchiv-Aktion:', data);
      const result = await ApiService.post('/fotoarchiv', {
        name: data.name,
        datum: data.datum,
        ort: data.ort,
        ersteller: data.ersteller || '' // Ersteller (account.username)
      });
      console.log('✅ Fotoarchiv-Aktion erstellt:', result);
      return result;
    } catch (error) {
      console.error('❌ Fehler beim Erstellen der Fotoarchiv-Aktion:', error);
      throw error;
    }
  }

  // Lade Fotos zu einer Aktion hoch
  async uploadPhotos(aktionId, files) {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file);
      });

      console.log('📤 Lade', files.length, 'Fotos zu Aktion', aktionId, 'hoch...');
      const result = await ApiService.postFormData(`/fotoarchiv/${aktionId}/upload`, formData);
      console.log('✅ Fotos erfolgreich hochgeladen:', result);
      return result;
    } catch (error) {
      console.error('❌ Fehler beim Hochladen der Fotos:', error);
      throw error;
    }
  }

  // Lade Fotos einzeln hoch mit Fortschritts-Callback
  async uploadPhotosWithProgress(aktionId, files, onProgress) {
    try {
      const totalFiles = files.length;
      let uploadedCount = 0;

      // Bilder einzeln hochladen
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append('files', file);

        console.log(`📤 Lade Foto ${i + 1}/${totalFiles} hoch...`);

        await ApiService.postFormData(`/fotoarchiv/${aktionId}/upload`, formData);

        uploadedCount++;

        // Callback aufrufen mit Fortschritt
        if (onProgress) {
          onProgress(i, file);
        }

        console.log(`✅ Foto ${i + 1}/${totalFiles} hochgeladen`);
      }

      console.log('✅ Alle Fotos erfolgreich hochgeladen');
      return { success: true, uploadedCount };
    } catch (error) {
      console.error('❌ Fehler beim Hochladen der Fotos:', error);
      throw error;
    }
  }
  // Schließt eine Fotoarchiv-Aktion ab (POST /fotoarchiv/:id/fertig)
  async fertig(aktionId) {
    try {
      console.log('✅ Schließe Fotoarchiv-Aktion ab:', aktionId);
      const result = await ApiService.post(`/fotoarchiv/${aktionId}/fertig`, {});
      console.log('✅ Fotoarchiv-Aktion abgeschlossen:', result);
      return result;
    } catch (error) {
      console.error('❌ Fehler beim Abschließen der Fotoarchiv-Aktion:', error);
      throw error;
    }
  }
}

export default new FotoarchivService();

